export const RESTAURANT_ZOOM_LEVEL_THRESHOLD = 9
